.statList {
  display: flex;
  flex-direction: column;

  .statRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 0;
    border-bottom: 1px solid var(--vc-border);
    font-size: var(--vc-text-sm);

    &:last-child {
      border-bottom: 0;
    }
  }

  .statKey {
    color: var(--vc-text-muted);
    flex: none;
  }

  .statValue {
    font-weight: var(--vc-weight-semibold);
    text-align: right;
    min-width: 0;
    overflow-wrap: anywhere;
  }

  // Long values sit under their label, left-aligned, so neither side gets squeezed.
  .stacked {
    flex-direction: column;
    align-items: stretch;
    gap: 4px;

    .statValue {
      text-align: left;
      line-height: 1.4;
    }
  }
}
